import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Card, CardContent, Typography } from '@material-ui/core';

const MakesToolBar = (props) => {
  const navigate = useNavigate();

  const goToAdd = () => {
    navigate('/app/categories/add');
  };

  return (
    <Box {...props}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
        }}
      >
        <Button color="primary" variant="contained" onClick={goToAdd}>
          ADD CATEGORY
        </Button>
      </Box>
      <Box sx={{ mt: 3 }}>
        <Card>
          <CardContent>
            <Box sx={{ maxWidth: 500 }}>
              <Typography>Categories</Typography>
            </Box>
          </CardContent>
        </Card>
      </Box>
    </Box>
  );
};

export default MakesToolBar;
